import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const purchaseOrderCreateRBAC = {
  pageID: '9a2fb97cece476b0cd2bf2d61edf7762',
  elementID: {
    BtnActionArrived: '8d9b44851cf098a1e9cbd2e858255193',
    BtnActionCancel: '91fcc9b85205a3d640f20a869391b15e',
    BtnActionPrint: 'dfcf7f725f48591aafbfc0c24d1ad9fd',
    BtnActionDownload: '1f71f472120bcf3ab90023021feb6840',
    BtnActionDelivery: '8e004120f20bcf3ab915eae141fa9d88',
    BtnActionCheckQuantity: '70c95f2732396edbbdb9c7b1927eb487',
    BtnActionPrintGrn: 'b3fa28884f0bcf3aedeab2295c075060',
    BtnActionEdit: '62f194ec6554c01466f53b203b73f6fc',
    BtnActionConfirm: 'cc3de4a63ff098a1e9d31c0d5fdebf58',
  },
} as const

export const useRBACPurchaseOrderCreate = createUseRBAC(purchaseOrderCreateRBAC.elementID)
export type UseRBACPurchaseOrderCreateType = ReturnType<typeof useRBACPurchaseOrderCreate>

export const purchaseOrderInboundHubRBAC = {
  pageID: '6d540eb8b6f80e34fa08a5d7ac628131',
  elementID: {
    BtnActionCancel: '1ad89d10c176f865e55d85710e244b8f',
    BtnActionPrint: 'de1f580a5afab054d817dda6682168c6',
    BtnActionDownload: '86ffcc57a99c7ea2935a364b3256e1d5',
    BtnActionDelivery: 'c8215e0c819c7ea2936cbfc32ad070a1',
    BtnActionArrived: '5553d92dda63a5613a1aa1b61fddd64c',
    BtnActionCheckQuantity: 'e02bb5c8d1068025d8242210ddd8f820',
    BtnActionPrintGrn: '762edc36949c7ea2c7dbaf12ff1a52b9',
    BtnActionEdit: 'af6ec75753a355e4a339c7006eefd23d',
    BtnActionConfirm: '16b195bc9763a5613a1358913e890c3f',
  },
} as const
export const useRBACPurchaseOrderInboundHub = createUseRBAC(purchaseOrderInboundHubRBAC.elementID)
export type UseRBACPurchaseOrderInboundHubType = ReturnType<typeof useRBACPurchaseOrderInboundHub>

export const purchaseOrderInboundWarehouseRBAC = {
  pageID: '6b799adb8dcd375c19a5c2dffb4ad245',
  elementID: {
    BtnActionCancel: 'ded95dcaca16f5a25fba2af3ddff8e6b',
    BtnActionPrint: 'd1b9c6a52379fa4738614d39d3680c12',
    BtnActionDownload: '41c9871a4d0d44c1a29b40c9b0ea98b1',
    BtnActionDelivery: '698a85a2a50d44c1a2b0f71c7a25669d',
    BtnActionArrived: '9ba3eb4203403ecbca19f10e40b970d0',
    BtnActionCheckQuantity: 'fea3b467f94eaa7091ded4a1cb9b40d4',
    BtnActionPrintGrn: 'ac7e2165d80d44c16d7ad450190827fd',
    BtnActionEdit: '49faa731a853484fdedbbccaa030eab9',
    BtnActionConfirm: '6fd9fc8748403ecbca12eb88bbb8be6b',
  },
} as const
export const useRBACPurchaseOrderInboundWarehouse = createUseRBAC(
  purchaseOrderInboundWarehouseRBAC.elementID,
)
export type UseRBACPurchaseOrderInboundWarehouseType = ReturnType<
  typeof useRBACPurchaseOrderInboundWarehouse
>

/**
 * Temporary hide page megahub sama approval
 
export const purchaseOrderInboundMegahubRBAC = {
  pageID: '6e38b2fc5db3eda77aa30907143cea63',
  elementID: {
    BtnActionCancel: '19d4748b6989b001698113249148ebfd',
    BtnActionPrint: 'fea1702c0218d16c17e737757ddec7b4',
    BtnActionDownload: '6a3d82ec885c53563ca242354bffdf97',
    BtnActionDelivery: '941f976df45c53563c8cde9811187e3b',
    BtnActionArrived: '7012f05c576b91bcd1cdeab355d0976e',
    BtnActionCheckQuantity: '7048fd297bf6a6622c73620f21918f4e',
    BtnActionPrintGrn: '2af31e10035c53566e515382824d2127',
    BtnActionEdit: '6103a78f852096338b0c1c9ec1107cbf',
    BtnActionConfirm: '047bc58f446b91bcd1d293cfd1f457f9',
  },
} as const

export const useRBACPurchaseOrderInboundMegahub = createUseRBAC(
  purchaseOrderInboundMegahubRBAC.elementID,
)
export type UseRBACPurchaseOrderInboundMegahubType = ReturnType<
  typeof useRBACPurchaseOrderInboundMegahub
>

export const purchaseOrderApprovalRBAC = {
  pageID: 'cac7948d7ef7e229018811e016c195cf',
  elementID: {
    BtnActionApprove: '8712f66a9b89e1ff6e407b4a918f71be',
    BtnActionReject: '69f19e0c079c79cf3c7d37a8b9eb7762',
  },
}
export const useRBACPurchaseOrderApproval = createUseRBAC(purchaseOrderApprovalRBAC.elementID)
export type UseRBACPurchaseOrderApprovalType = ReturnType<typeof useRBACPurchaseOrderApproval>

*/
